export default {
  days: state => state.days
}
